import classNames from 'classnames';
import {Field, FieldProps} from 'formik';
import React, {useRef, useEffect} from 'react';
import {withTrackFont} from '../../../containers/DataContainer/siteSettings/withTrackFont';
import {withoutSize} from '../../../services/env/siteSettings/fonts/fonts';
import styles from './TextInput.scss';

interface IProps {
  className?: string;
  name: string;
  trackFont?: {};
}

const InputField: React.FunctionComponent<IProps> = ({className, name, trackFont, ...props}) => {
  const fontStyles = withoutSize(trackFont);
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <Field name={name}>
      {({field, form: {touched, errors}}: FieldProps) => {
        const isShowError = touched[field.name] && errors[field.name];

        // Focus input when there's an error
        useEffect(() => {
          if (isShowError && inputRef.current) {
            inputRef.current.focus();
          }
        }, [isShowError]);

        const inputClassName = classNames(styles.textInput, className, {
          [styles.textInput__error]: isShowError,
        });
        const errorMessageClassName = classNames(styles.errorMessage, {
          [styles.errorMessage__show]: isShowError,
        });

        return (
          <div className={styles.inputContainer}>
            <input
              ref={inputRef}
              aria-describedby="error-message"
              className={inputClassName}
              style={fontStyles}
              {...field}
              {...props}
              {...(isShowError ? { 'aria-invalid': true } : {})}
            />
            <div
              id="error-message"
              className={errorMessageClassName}
              style={fontStyles}
              role="alert"
              aria-live="assertive"
              data-hook="error-message"
            >
              {errors[field.name]}
            </div>
          </div>
        );
      }}
    </Field>
  );
};

export const TextInput = withTrackFont(InputField);
